import React from 'react'
import styles from './Style.module.css'

const STATUS_COPY = {
  confirmed: {
    title: "Your appointment is confirmed",
    subTitle: "",
  },
  updated: {
    title: "Your appointment is updated",
    subTitle: "",
  },
  "checked-in": {
    title: "This appointment has been Checked-in.",
    subTitle: "",
  },
  completed: {
    title: "This appointment has been completed.",
    subTitle: "",
  },
  voided: {
    title: "This appointment has been voided.",
    subTitle: "",
  },
  canceled: {
    title: "This appointment has been cancelled.",
    subTitle: "",
  },
  cancelled: {
    title: "This appointment has been cancelled.",
    subTitle: "",
  },
  "no-show": {
    title: "Your appointment date has passed.",
    subTitle: "It can no longer be rescheduled or cancelled online.",
  },
  holding: {
    title: "This appointment is on hold.",
    subTitle: "",
  },
};

const BookingStatus = ({
    badge,
    status,
}) => {
  const { title = "", subTitle = "" } = STATUS_COPY[status?.toLowerCase()] || {};

  return (
    <div className={styles.bookingStatus}>
        <img
        src={badge}
        className={styles.badge}
        alt={status?.toLowerCase() === 'no-show' ? 'Past booking' : status}
        />
        <div className={`${styles.content} title-main-container`}>
            <h1 className="title-main">
              {title}
            </h1>
            {subTitle && <p className="title-sub">{subTitle}</p>}
        </div>
    </div>
  )
}

export default BookingStatus
